/**
 * The TCU emits a cumulative lifetime total on its first camera frame (see
 * backend-ai/docs/CAMERA_ROOT_PROTOCOL.md) — e.g. countOk = 30268 against a
 * typical per-point 0..21. Left in, that one value stretches a colour ramp so
 * far that every real reading collapses onto its first stop, and swamps every
 * per-point average.
 *
 * Returns the value above which a reading is a dump rather than a real count:
 * eight times the median, never below 200. Shared by the Tracks map layers and
 * the admin device metrics, which each used to carry a copy.
 */
export function cameraDumpThreshold(values: (number | null)[]): number {
  const sorted = values
    .filter((v): v is number => v != null)
    .sort((a, b) => a - b);
  const median = sorted.length ? sorted[Math.floor(sorted.length / 2)] : 0;
  return Math.max(median * 8, 200);
}
